import io from 'socket.io-client'
import Config from '@/config'
import store from '@/vuex/store'

let socket = null

export default {
  initialize: () => {
    socket = io(Config.baseUrlSocket, {
      path: '/api/socket.io-client',
      query: {
        type: 'presenter',
      },
      transports: ['websocket'],
      withCredentials: true,
    })

    // https://ahaslides.atlassian.net/browse/AHA-4956
    // on reconnection, reset the transports option, as the Websocket
    // connection may have failed (caused by proxy, firewall, browser, ...)
    socket.io.on('reconnect_attempt', (attempts) => {
      // show the connection problem popup if failed after retrying 3 times (~ 15 seconds of retrying)
      if (attempts > 3) {
        store.commit('setSocketDisconnected', true)
      }

      socket.io.opts.transports = ['polling', 'websocket']
    })

    socket.on('connect', () => {
      store.commit('setSocketDisconnected', false)
      store.commit('setSocketId', socket.id)
    })
  },

  subscribe: (channel, callback) => {
    socket.on(channel, (doc) => {
      return callback(doc)
    })
  },

  unSubscribe: (channel) => {
    if (!socket) {
      return
    }
    socket.removeAllListeners(channel)
  },

  getSocketId: () => {
    return socket.id
  },

  close: () => {
    if (!socket) return
    socket.close()
  },

  getSocket: () => {
    return socket
  },
  on(...props) {
    return socket.on(...props)
  },
  off(...props) {
    return socket.off(...props)
  },
  emit(...props) {
    return socket.emit(...props)
  },
}
